import React from "react"
import Nav from "../Components/Outlets/Nav"
import Footer from "../Components/Outlets/Footer"
import { Link } from "react-router-dom"
import { motion } from "framer-motion"

const ADMISSION_URL = "https://admission.branmont.com/"

const programs = [
	{
		icon: "ri-flask-line",
		color: "#174e4a",
		tag: "Science",
		title: "Science Stream – Board + Entrance Coaching",
		items: [
			"Strong +1 & +2 board academics",
			"NEET, JEE, KEAM & CUET coaching",
			"Integrated exam preparation",
			"Regular testing & mentoring",
		],
	},
	{
		icon: "ri-briefcase-4-line",
		color: "#3a2942",
		tag: "Commerce",
		title: "Commerce Stream – Professional Courses",
		items: [
			"+1 & +2 commerce academics",
			"CA Foundation preparation",
			"CMA Foundation preparation",
			"Professional & career pathways",
		],
	},
	{
		icon: "ri-global-line",
		color: "#174e4a",
		tag: "Global",
		title: "Global University Opportunities",
		items: [
			"International university admissions",
			"Global scholarship guidance",
			"Personality & profile development",
			"Career counseling for global markets",
		],
	},
	{
		icon: "ri-book-open-line",
		color: "#c4935a",
		tag: "Exams",
		title: "National Entrance Exams",
		items: [
			"NEET, JEE, KEAM & CUET",
			"Other national-level competitive exams",
			"Specialized coaching & resources",
			"Expert mentorship & guidance",
		],
	},
]

const processSteps = [
	{
		number: "01",
		icon: "ri-file-text-line",
		title: "Application Submission",
		desc: "Fill and submit your admission application form online or in person.",
	},
	{
		number: "02",
		icon: "ri-team-line",
		title: "Counseling & Interaction",
		desc: "Meet our team for a counseling session and academic interaction.",
	},
	{
		number: "03",
		icon: "ri-shield-check-line",
		title: "Admission Confirmation",
		desc: "Complete the joining formalities and confirm your seat at Branmont.",
	},
]

const Acadamics = () => {
	return (
		<div>
			<Nav />

			<div className="page-breadcrumb-bar">
				<div className="container-main">
					<div className="breadcrumb-inner">
						<h1 className="breadcrumb-page-title montserrat">Programs</h1>
						<nav className="breadcrumb-nav-links">
							<Link to="/">Home</Link>
							<i className="ri-arrow-right-s-line"></i>
							<span>Programs</span>
						</nav>
					</div>
				</div>
			</div>

			<section className="acad-programs-section">
				<div className="container-main">

					<div className="acad-section-header">
						<span className="acad-eyebrow">What We Offer</span>
						<h2 className="acad-section-title montserrat">Career-Integrated Programs</h2>
						<p className="acad-section-desc">
							Structured education pathways designed to take you from +1 to a global career — all under one roof, exclusively for boys.
						</p>
					</div>

					<div className="acad-programs-grid">
						{programs.map((prog, idx) => (
							<motion.div
								className="acad-program-card"
								key={idx}
								initial={{ opacity: 0, y: 24 }}
								whileInView={{ opacity: 1, y: 0 }}
								viewport={{ once: true }}
								transition={{ duration: 0.5, delay: idx * 0.07 }}
							>
								<div className="acad-card-top">
									<div
										className="acad-card-icon"
										style={{ background: prog.color + "14", color: prog.color }}
									>
										<i className={prog.icon}></i>
									</div>
									<span
										className="acad-card-tag"
										style={{ background: prog.color + "18", color: prog.color }}
									>
										{prog.tag}
									</span>
								</div>
								<h3 className="acad-card-title">{prog.title}</h3>
								<ul className="acad-card-list">
									{prog.items.map((item, i) => (
										<li key={i}>
											<i className="ri-check-double-line"></i>
											<span>{item}</span>
										</li>
									))}
								</ul>
								<div
									className="acad-card-accent"
									style={{ background: prog.color }}
								/>
							</motion.div>
						))}
					</div>
				</div>
			</section>

			<section className="acad-process-section">
				<div className="container-main">
					<div className="acad-section-header">
						<span className="acad-eyebrow">How to Join</span>
						<h2 className="acad-section-title montserrat">Admission Process</h2>
						<p className="acad-section-desc">Three simple steps to secure your seat at Branmont.</p>
					</div>

					<div className="acad-process-grid">
						{processSteps.map((step, idx) => (
							<motion.div
								className="acad-process-card"
								key={idx}
								initial={{ opacity: 0, y: 24 }}
								whileInView={{ opacity: 1, y: 0 }}
								viewport={{ once: true }}
								transition={{ duration: 0.5, delay: idx * 0.1 }}
							>
								<div className="acad-process-num">{step.number}</div>
								<div className="acad-process-icon">
									<i className={step.icon}></i>
								</div>
								<h3>{step.title}</h3>
								<p>{step.desc}</p>
							</motion.div>
						))}
					</div>

					<div className="acad-process-cta">
						<a
							className="acad-apply-btn"
							href={ADMISSION_URL}
							target="_blank"
							rel="noopener noreferrer"
						>
							Apply Now <i className="ri-arrow-right-line"></i>
						</a>
					</div>
				</div>
			</section>

			<Footer />
		</div>
	)
}

export default Acadamics
